import { useReveal } from '../hooks/useReveal';
import { getBlock } from '../content';

export default function Numbers() {
  const ref = useReveal();
  const { stats } = getBlock('home.numbers');

  return (
    <>
      <div className="wave-up" style={{ background: 'var(--bg)' }}>
        <svg className="wave-svg" viewBox="0 0 1440 110" preserveAspectRatio="none">
          <path fill="#0A2447" d="M0 0 C 360 110, 720 110, 1080 55 S 1440 0 1440 0 V110 H0 Z" />
        </svg>
      </div>

      <div className="numbers">
        <div className="num-grid reveal" ref={ref}>
          {stats.map((s, i) => (
            <div key={i} className="num-cell">
              <div className="l">{s.label}</div>
              <div className="v">
                {s.value}
                {s.suffix && <em>{s.suffix}</em>}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="wave-down" style={{ background: 'var(--bg)' }}>
        <svg className="wave-svg" viewBox="0 0 1440 110" preserveAspectRatio="none">
          <path fill="#0A2447" d="M0 110 C 360 0, 720 0, 1080 55 S 1440 110 1440 110 V0 H0 Z" />
        </svg>
      </div>
    </>
  );
}
